import { Component } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.sass'],
})
export class GlobalLoaderComponent {
  state$ = this.loadingService.state$;

  constructor(private loadingService: LoadingService) {}
}
